<div>
  <div class="container">
    <div class="row">
      <div class="col">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="barChartOptions"
        ></highcharts-chart>
      </div>
      <div class="col">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="lineChartOptions"
        ></highcharts-chart>
      </div>
      <div class="col">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="pieChartOptions"
        ></highcharts-chart>
      </div>
      <div class="col">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="columnChartOptions"
        ></highcharts-chart>
      </div>
    </div>
  </div>

  <div class="container">
    <!-- Column toggle button -->
    <div class="d-flex justify-content-end">
      <button mat-icon-button [matMenuTriggerFor]="columnMenu">
        <mat-icon>settings</mat-icon>
      </button>
    </div>
    <div class="row">
      <mat-menu #columnMenu="matMenu">
        @for (col of columns; track col) {
          @if (col.key !== "select" && col.isCheckbox !== true) {
            <mat-checkbox
              [checked]="visibleFieldKeys.includes(col.key)"
              (change)="toggleColumnVisibility(col.key)"
            >
              {{ col.label }}
            </mat-checkbox>
          }
        }
      </mat-menu>
    </div>
  </div>

  <div class="container">
    <div class="row table-wrapper">
      <!-- Table -->
      <mat-table
        [dataSource]="sortedData"
        matSort
        matSortActive="name"
        matSortDirection="asc"
        class="mat-elevation-z8"
      >
        <!-- Dynamic columns -->
        @for (col of columns; track col) {
          <ng-container [matColumnDef]="col.key">
            <th mat-header-cell *matHeaderCellDef [sticky]="col.sticky">
              @if (col.key === "select") {
                <mat-checkbox
                  (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()"
                ></mat-checkbox>
              }
              @if (col.sortable) {
                <span [mat-sort-header]="col.key">{{ col.label }}</span>
              }
              @if (!col.sortable) {
                <span>{{ col.label }}</span>
              }
            </th>
            <td mat-cell *matCellDef="let row" [sticky]="row.sticky">
              @if (col.key === "select") {
                <mat-checkbox
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)"
                ></mat-checkbox>
              }
              @if (col.key !== "select") {
                <span>{{ row[col.key] }}</span>
              }
            </td>
            <!-- <td mat-cell *matCellDef="let row">{{ row[col.key] }}</td> -->
          </ng-container>
        }

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </mat-table>
    </div>
  </div>
  <!-- Paginator -->
  <mat-paginator
    [length]="this.dataSource.data.length"
    [pageIndex]="currentPageIndex"
    [pageSize]="currentPageSize"
    [pageSizeOptions]="[20, 50, 100, 200, 500]"
    (page)="onPageChange($event)"
    aria-label="Select page of results"
    class="paginator"
  >
  </mat-paginator>
</div>
